import { type StorageInterface } from './StorageInterface'

export class LocalStorageClient implements StorageInterface {
  get<T = any>(key: string): T | undefined {
    const storedValue = window.localStorage.getItem(key)

    if (storedValue == null) {
      return undefined
    }

    try {
      return JSON.parse(storedValue)
    } catch {
      return storedValue as unknown as T
    }
  }

  set<T = any>(key: string, value: T): void {
    const jsonValue = JSON.stringify(value)
    try {
      window.localStorage.setItem(key, jsonValue)
    } catch (error) {
      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        this.clear()
        alert('Local data storage was cleared to keep things working. Please, login again.')
      } else {
        throw error
      }
    }
  }

  delete(key: string): void {
    window.localStorage.removeItem(key)
  }

  clear(): void {
    window.localStorage.clear()
  }
}
